import React from "react";
import GonkBox from "views/GonkBox";
import PropTypes from "prop-types";

class GonkBoundary extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {hasError: false};
    }

    componentDidCatch(error, errorInfo) {
        this.setState({
            hasError: true,
            error,
            errorInfo,
        });
        console.error("GonkBoundary", error, errorInfo);
    }

    render() {
        if (this.state.hasError) {
            return <GonkBox>
                <p>{this.state.error.message}</p>
            </GonkBox>;
        }

        return this.props.children || null;
    }
}

GonkBoundary.propTypes = {
    children: PropTypes.any,
};

export default GonkBoundary;



// WEBPACK FOOTER //
// ./app/views/GonkBoundary.js